
import React from 'react';
import { useNavigate } from 'react-router-dom';

const noTaxStates = [
  { name: 'Alaska', abbr: 'AK', slug: 'ak', pop: '733K' },
  { name: 'Florida', abbr: 'FL', slug: 'fl', pop: '22.6M' },
  { name: 'Nevada', abbr: 'NV', slug: 'nv', pop: '3.2M' },
  { name: 'New Hampshire', abbr: 'NH', slug: 'nh', pop: '1.4M' },
  { name: 'South Dakota', abbr: 'SD', slug: 'sd', pop: '909K' },
  { name: 'Tennessee', abbr: 'TN', slug: 'tn', pop: '7.1M' },
  { name: 'Texas', abbr: 'TX', slug: 'tx', pop: '30.5M' },
  { name: 'Washington', abbr: 'WA', slug: 'wa', pop: '7.8M' },
  { name: 'Wyoming', abbr: 'WY', slug: 'wy', pop: '577K' },
];

const NoTaxStatesHighlight = () => {
  const navigate = useNavigate();

  // Graceful navigation fallback
  const handleNavigate = (path: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    try {
      navigate(path);
    } catch (err) {
      console.error('Navigation error:', err);
    }
  };

  return (
    <section className="py-16 bg-emerald-50 border-y border-emerald-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center bg-emerald-500 rounded-xl">
                <i className="ri-shield-check-line text-white text-lg"></i>
              </div>
              <h2 className="text-2xl font-bold text-emerald-900">
                <strong>9 States With Zero Income Tax</strong>
              </h2>
            </div>
            <p className="text-emerald-700 text-sm max-w-xl">
              These states don&apos;t charge any state income tax, meaning you keep significantly more of your salary. A $100K earner saves $3,000&ndash;$13,000 per year compared to high-tax states.
            </p>
          </div>
          <a
            href="/states"
            onClick={handleNavigate('/states')}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Compare All States <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-3">
          {noTaxStates.map((state) => (
            <a
              key={state.slug}
              href={`/states/${state.slug}`}
              onClick={handleNavigate(`/states/${state.slug}`)}
              className="group flex flex-col items-center p-4 bg-white hover:bg-emerald-500 border border-emerald-200 hover:border-emerald-500 rounded-xl transition-all cursor-pointer hover:-translate-y-1 hover:shadow-lg"
            >
              <span className="text-lg font-bold text-emerald-700 group-hover:text-white transition-colors">{state.abbr}</span>
              <span className="text-xs text-emerald-600 group-hover:text-emerald-100 mt-1 transition-colors text-center">{state.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NoTaxStatesHighlight;
